import { FETCH_FEE_SHIP_SUCCESS } from "redux/ActionTypes/PaymentTypes";

const initialState = {
  feeShip: {},
};

const PaymentReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FEE_SHIP_SUCCESS: {
      const newFeeShip = { ...action.payload };
      return { ...state, feeShip: newFeeShip };
    }
    default:
      return { ...state };
  }
};

export default PaymentReducers;
